export default [{
  path: '/pessoas',
  component: {
    name: 'pessoasBase',
    template: '<router-view />',
    meta: {
      resource: 'pessoa',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'pessoas',
    component: () => import('@/app-modulo/comercial/pessoa/PessoaView.vue'),
    meta: {
      resource: 'pessoa',
      action: 'read',
      requiredAuth: true,
      navActiveLink: 'pessoas',
      pageTitle: 'Cadastro de Pessoas',
      breadcrumb: [
        {
          text: 'Pessoas',
          to: { name: 'pessoas' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-pessoa',
    component: () => import('@/app-modulo/comercial/pessoa/shared/components/cadastro/Pessoa.vue'),
    meta: {
      resource: 'pessoa',
      action: 'create',
      requiredAuth: true,
      navActiveLink: 'pessoas',
      pageTitle: 'Cadastro de Pessoas',
      breadcrumb: [
        {
          text: 'Pessoas',
          to: { name: 'pessoas' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-pessoa' },
          active: true,
        },
      ],
    },
  }, {
    path: 'editar/:id',
    name: 'editar-pessoa',
    component: () => import('@/app-modulo/comercial/pessoa/shared/components/cadastro/Pessoa.vue'),
    meta: {
      resource: 'pessoa',
      action: 'update',
      requiredAuth: true,
      navActiveLink: 'pessoas',
      pageTitle: 'Cadastro de Pessoas',
      breadcrumb: [
        {
          text: 'Pessoas',
          to: { name: 'pessoas' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-pessoa' },
          active: true,
        },
      ],
    },
  }],
},
]
